export default function Pagination({ current_page, total_pages, onPageChange }) {
  if (total_pages <= 1) return null

  const pages = buildPageList(current_page, total_pages)

  return (
    <div className="flex items-center gap-1 font-mono text-sm mt-4">
      <PageBtn onClick={() => onPageChange(current_page - 1)} disabled={current_page === 1}>
        ‹
      </PageBtn>

      {pages.map((p, i) =>
        p === "..." ? (
          <span key={`ellipsis-${i}`} className="px-2 text-zinc-600">…</span>
        ) : (
          <PageBtn
            key={p}
            onClick={() => onPageChange(p)}
            active={p === current_page}
          >
            {p}
          </PageBtn>
        )
      )}

      <PageBtn onClick={() => onPageChange(current_page + 1)} disabled={current_page === total_pages}>
        ›
      </PageBtn>
    </div>
  )
}

function PageBtn({ onClick, disabled, active, children }) {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={[
        "min-w-[2rem] px-2 py-1 rounded-md text-xs transition-all",
        active
          ? "bg-emerald-900/50 text-emerald-300 border border-emerald-700/60 shadow-[0_0_8px_0_theme(colors.emerald.900/50)]"
          : "text-zinc-500 hover:text-zinc-100 hover:bg-zinc-800 border border-transparent",
        disabled && "opacity-25 cursor-not-allowed",
      ].filter(Boolean).join(" ")}
    >
      {children}
    </button>
  )
}

function buildPageList(current, total) {
  if (total <= 7) return Array.from({ length: total }, (_, i) => i + 1)

  const pages = []
  const delta = 2

  pages.push(1)
  if (current - delta > 2) pages.push("...")
  for (let p = Math.max(2, current - delta); p <= Math.min(total - 1, current + delta); p++) {
    pages.push(p)
  }
  if (current + delta < total - 1) pages.push("...")
  pages.push(total)

  return pages
}
